// extracted by mini-css-extract-plugin
export default {"card":"EmailChangeCard_card__uiFzK","title":"EmailChangeCard_title__4cOWO","content":"EmailChangeCard_content__RXJah","row":"EmailChangeCard_row__nvjw8"};